import React from 'react';

import genesis_img from '../../../../images/genesis_logo.jpg';
import realtime_img from '../../../../images/realtime_logo.jpg';
import powerschool_img from '../../../../images/powerschool_logo.jpg';
import facts_img from '../../../../images/facts.png';
import skyward_img from '../../../../images/skyward_logo.jpg';
import infinite_campus_img from '../../../../images/infinite_campus_logo.jpg';
import gradelink_img from '../../../../images/gradelink_logo.jpg';

export default function ScrollingSchools() {

    return (
        <>
        <h3 className='sis-list-heading text-align-center dark-blue-text'>Compatible with most SIS</h3>
        <div id='homepage-sis-container'>
            <img className="homepage-sis-logo" src={genesis_img} alt='genesis logo'/>
            <img className="homepage-sis-logo" src={realtime_img} alt='realtime logo'/>
            <img className="homepage-sis-logo" src={powerschool_img} alt='powerschool logo'/>
            <img className="homepage-sis-logo" src={facts_img} alt='facts logo'/>
            {/* <img className="homepage-sis-logo" src={skyward_img} alt='skyward logo'/> */}
            <img className="homepage-sis-logo" src={infinite_campus_img} alt='infinite campus logo'/>
            <img className="homepage-sis-logo" src={gradelink_img} alt='gradelink logo'/>
        </div>
        <h3 className='text-align-center'>... and more!</h3>
        </>
    );
}

